import {Chip, Tooltip} from "@mui/material";

const Tag = ({title}: { title: string }) => {
	return (
		<Tooltip title={title}>
			<Chip
				label={title}
				sx={(theme) => ({
					maxWidth: 300,
					height: 'auto',
					'& .MuiChip-label': {
						display: 'block',
						whiteSpace: 'normal',
						paddingTop: '4px',
						paddingBottom: '4px',
					},
					...theme.typography.caption1
				})}
			/>
		</Tooltip>
	)
}

export default Tag;